module.exports = __webpack_public_path__ + "img/51be7cde8b89133a0996be3a55802701.799d7b1a.png";